import { api } from "./client";

// Cross-fleet optic row (org-scoped) — backs the Results explorer.
export interface OrgOptic {
  id: string;
  ref: string | null;
  device_id: string;
  device_serial: string | null;
  device_label: string | null;
  received_at: string;
  captured_at: string | null;
  debug: boolean;
  hidden: boolean;
  cryodeck_bottle_issued_id: number | null;
  has_dump: boolean;
  pathogen_ids: number[];
}

export const resultsApi = {
  listOrgOptics: (limit = 200) =>
    api.get<{ optics: OrgOptic[] }>(`/api/dashboard/optics?limit=${limit}`),
};
